import { useState } from 'react';
import { faqItems } from '@/mocks/comics';

export default function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);

  const toggleFAQ = (index: number) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <section className="py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-2xl md:text-4xl font-heading font-bold text-foreground-900">
            常见<span className="text-secondary-500">问题</span>
          </h2>
          <p className="mt-3 text-sm md:text-base text-foreground-600 max-w-lg mx-auto">
            关于韩漫画网，您可能想了解的问题
          </p>
        </div>

        <div className="max-w-3xl mx-auto flex flex-col gap-3">
          {faqItems.map((item, index) => (
            <div
              key={index}
              className="rounded-xl bg-background-100 border border-background-200/70 overflow-hidden transition-all duration-200"
            >
              <button
                type="button"
                className="w-full flex items-center justify-between px-5 py-4 text-left cursor-pointer"
                onClick={() => toggleFAQ(index)}
              >
                <h4 className="text-sm md:text-base font-medium text-foreground-900 pr-4">
                  {item.question}
                </h4>
                <span
                  className={`w-5 h-5 flex items-center justify-center flex-shrink-0 text-foreground-500 transition-transform duration-300 ${
                    openIndex === index ? 'rotate-180' : ''
                  }`}
                >
                  <i className="ri-arrow-down-s-line"></i>
                </span>
              </button>
              <div
                className={`overflow-hidden transition-all duration-300 ${
                  openIndex === index ? 'max-h-96 pb-4 px-5' : 'max-h-0'
                }`}
              >
                <p className="text-sm text-foreground-600 leading-relaxed">
                  {item.answer}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}